import { takeLatest, Effect } from 'redux-saga/effects';
import { types as mainMenuTypes, actions as mainMenuActions } from 'ducks/mainMenu';
import { connectSagaToApi } from './utils';
import * as api from 'api/mainMenu';

export default function* rootCustomerSaga(): IterableIterator<Effect> {
  yield takeLatest(mainMenuTypes.fetchMainMenu, connectSagaToApi(mainMenuActions, 'fetchMainMenu', api.getMainMenu));
}
